import React, { useContext } from 'react';

import { app, media } from 'context';
import { Animate, Layout, Text } from 'ds';
import { actions } from 'store/ServicesRequest';
import { selectServicesRequestSqft } from 'store/ServicesRequest/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import ServicesRequestBottomSheet from './ServicesRequestBottomSheet';
import ServicesRequestNumberStepper from './ServicesRequestNumberStepper';
import StepContainer from './StepContainer';
import StepTitle from './StepTitle';
import { generateServicesRequestStepPath } from './utils';

interface Props {}

const ServicesRequestSize: React.FC<Props> = () => {
  const sqft = useAppSelector(selectServicesRequestSqft);
  const dispatch = useAppDispatch();
  const { xs, sm } = useContext(media);
  const isMobile = xs || sm;
  const { isSmallPhone } = useContext(app);

  const NumberStepper = (
    <ServicesRequestNumberStepper
      data-cy="size-stepper"
      onChange={value => {
        dispatch(actions.setSqft(value));
      }}
      value={sqft}
      stepValue={100}
      max={1000000}
      suffix="ft²"
    />
  );

  const content = (
    <Layout>
      {NumberStepper}
      <Layout marginTop={isMobile ? 12 : 48}>
        <Text size="body-sm" color="gray-700">
          This helps us assess the cost of your services.
        </Text>
      </Layout>
    </Layout>
  );

  return (
    <StepContainer
      step="size"
      nextHref={generateServicesRequestStepPath({ step: 'move' })}
      backHref={generateServicesRequestStepPath({ step: 'location' })}
      ctaDisabled={!sqft}
      stepCompletedEventValue={sqft}
      stepName="size"
      skippable
    >
      <StepTitle>How large is your space?</StepTitle>
      {isMobile ? (
        <ServicesRequestBottomSheet>
          <Layout justify="center" paddingBottom={isSmallPhone ? 36 : 48}>
            {content}
          </Layout>
        </ServicesRequestBottomSheet>
      ) : (
        <Animate justify="center">{NumberStepper}</Animate>
      )}
    </StepContainer>
  );
};

export default ServicesRequestSize;
